// extracted by mini-css-extract-plugin
module.exports = {"VideoPlayer":"styles_VideoPlayer__vfrqV","video":"styles_video__91PQP","controls":"styles_controls__jLR0X","progressBar":"styles_progressBar__a4yd1"};